import styled from 'styled-components';
import colors from '../../../config/colors.json';

export const Card = styled.div`
    border-radius: 8px;
    border: 1px solid ${colors.lightGrey9};
    background-size: transparent;
    opacity: 1;
    padding: 15px;
    > :last-child{
        border: none;
        padding-bottom: 0;
    }
`;

export const CardRow = styled.div`
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${colors.lightGrey9};
`;

export const SummaryValue = styled.div`
    font-size: 14px;
	font-weight: ${({ bold }) => (bold ? '500' : 'Regular')};
    color: ${colors.darkGrey};
    text-transform: capitalize;
    &.red {
        color: ${colors.redButtons};
    }
`;

export const StyledLink = styled.span`
    color: ${colors.red};
    text-decoration: underline;
    cursor: pointer;
`;

export const CloseModalSpan = styled.span`
    color: ${colors.darkGrey};
    font-size: 43px;
    font: Poppins;
    position: absolute;
    left: calc(100% - 50px);
    top: 10px;
    cursor: pointer;
`;

export const StyledH2 = styled.h2`
    font-family: 'Poppins', Arial, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 21px;
    text-align: left;
    color: ${colors.dark};
    margin-bottom: 10px;
    font-weight: 600;
`;

export const ModalContent = styled.div`
	text-align: center;
	font-family: 'Poppins', Arial, Helvetica, sans-serif;
	font-size: 14px;
	line-height: 21px;
	padding: 60px 110px;
	font: Poppins;
	color: ${colors.grey};
`;

export const SummarySpan = styled.div`
	font-size: 12px;
	color: ${colors.lightGrey10a};
`;
